import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "answer" }

import { QuizAnswer } from '@/models/quiz-question.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizAnswersField',
  props: {
  modelValue: {
    type: Object as PropType<QuizAnswer[]>,
    required: true,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const answers = ref<QuizAnswer[]>([
  ...(props.modelValue || []).sort((a, b) => a.index - b.index),
]);

const emit = __emit;

function update() {
  emit('update:modelValue', answers.value);
  emit('change');
}

function addStep() {
  answers.value.push({ text: '', correct: false, index: answers.value.length });
  update();
}

function removeStep(index: number) {
  answers.value.splice(index, 1);
  update();
}

function moveUp(answer: QuizAnswer) {
  const index = answers.value.findIndex((a) => a.id === answer.id);

  answers.value = [
    ...answers.value.slice(0, index - 1),
    answer,
    answers.value[index - 1],
    ...answers.value.slice(index + 1),
  ].map((v, index) => ({ ...v, index }));

  update();
}

function moveDown(answer: QuizAnswer) {
  const index = answers.value.findIndex((a) => a.id === answer.id);

  answers.value = [
    ...answers.value.slice(0, index),
    answers.value[index + 1],
    answer,
    ...answers.value.slice(index + 2),
  ].map((v, index) => ({ ...v, index }));

  update();
}

watch(
  () => props.modelValue,
  () => {
    Object.assign(
      answers.value,
      (props.modelValue || []).sort((a, b) => a.index - b.index),
    );
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Answers", -1)),
    _createVNode(_component_v_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value, (answer, index) => {
          return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_text_field, {
                  modelValue: answer.text,
                  "onUpdate:modelValue": ($event: any) => ((answer.text) = $event),
                  label: "Answer",
                  placeholder: `Answer ${index + 1}`,
                  required: "",
                  onChange: update
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                _createVNode(_component_v_checkbox, {
                  modelValue: answer.correct,
                  "onUpdate:modelValue": ($event: any) => ((answer.correct) = $event),
                  label: "Correct"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _cache[0] || (_cache[0] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-arrow-up",
                  class: "remove-button",
                  density: "compact",
                  disabled: index === 0,
                  onClick: _withModifiers(($event: any) => (moveUp(answer)), ["prevent"])
                }, null, 8, ["disabled", "onClick"]),
                _cache[1] || (_cache[1] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-arrow-down",
                  class: "remove-button",
                  density: "compact",
                  disabled: index === answers.value.length - 1,
                  onClick: _withModifiers(($event: any) => (moveDown(answer)), ["prevent"])
                }, null, 8, ["disabled", "onClick"]),
                _cache[2] || (_cache[2] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete-outline",
                  class: "remove-button",
                  density: "compact",
                  onClick: _withModifiers(($event: any) => (removeStep(index)), ["prevent"])
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, { onClick: addStep }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("Add answer")
      ])),
      _: 1
    })
  ]))
}
}

})